import { useEffect, useState } from 'react';
import { Checkbox } from 'shared-ui';
import { CircularProgress } from '@mui/material';
import debounce from 'debounce';

import { AppMessages } from 'i18n/messages';
import { useLocale } from 'hooks/useLocale/useLocale';
import * as Styled from '../TreeMultiSelect.styles';

import { GroupedTreeMultiSelectBodyProps } from './GroupedTreeMultiSelectBody.types';
import { MultiTreeSelectGroupTypeEnum } from './GroupedTreeMultiSelectBody.enum';

export const GroupedTreeMultiSelectBody = ({
  renderOrganizationsGroupBody,
  extraGroupProps,
  onSelectItem,
  isOptionSelected,
  clearSelectedItems,
  isPopoverOpen,
}: GroupedTreeMultiSelectBodyProps) => {
  const { formatMessage } = useLocale();

  const [selectedGroup, setSelectedGroup] = useState(MultiTreeSelectGroupTypeEnum.EXTRA);

  const handleGroupSelect = (groupType: MultiTreeSelectGroupTypeEnum) => {
    setSelectedGroup(groupType);
    clearSelectedItems();
    extraGroupProps.onGroupSelect && extraGroupProps.onGroupSelect(groupType);
  };

  const handleSearch = debounce((search: string) => {
    extraGroupProps.onSearch?.(search);
  }, 600);

  useEffect(() => {
    handleSearch('');
  }, [isPopoverOpen]);

  return (
    <>
      <Styled.PopupHeaderWrapper>
        <Styled.HeaderOption
          onClick={() => handleGroupSelect(MultiTreeSelectGroupTypeEnum.EXTRA)}
          $isActive={selectedGroup === MultiTreeSelectGroupTypeEnum.EXTRA}
        >
          {extraGroupProps.label}
        </Styled.HeaderOption>
        <Styled.HeaderOption
          onClick={() => handleGroupSelect(MultiTreeSelectGroupTypeEnum.ORGANIZATIONS)}
          $isActive={selectedGroup === MultiTreeSelectGroupTypeEnum.ORGANIZATIONS}
        >
          {formatMessage({ id: AppMessages['groupedTreeMultiSelect.cell'] })}
        </Styled.HeaderOption>
      </Styled.PopupHeaderWrapper>

      {selectedGroup === MultiTreeSelectGroupTypeEnum.ORGANIZATIONS ? (
        renderOrganizationsGroupBody()
      ) : (
        <>
          {extraGroupProps.onSearch && (
            <Styled.ExtraGroupSearchWrapper>
              <Styled.ExtraGroupSearchInput
                placeholder={formatMessage({ id: AppMessages['common.list.placeholderWithSearch'] })}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {extraGroupProps.isLoading && <CircularProgress size={16} />}
            </Styled.ExtraGroupSearchWrapper>
          )}
          {extraGroupProps.options.map((option) => (
            <Styled.ListItemWrapper onClick={() => onSelectItem(option)} key={option.id}>
              <Styled.ListItem $isFirstLevel={true}>
                <Styled.ExtraGroupOption>
                  <Checkbox checked={isOptionSelected(option.id)} color="primary" />

                  {extraGroupProps.renderOption(option)}
                </Styled.ExtraGroupOption>
              </Styled.ListItem>
            </Styled.ListItemWrapper>
          ))}
        </>
      )}
    </>
  );
};
